import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-save-card-failed-signup',
  templateUrl: './save-card-failed-signup.component.html',
  styleUrls: ['./save-card-failed-signup.component.scss']
})
export class SaveCardFailedSignupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
